module.exports = __webpack_public_path__ + "static/media/block-4-sunnybank.78fde0f1.png";